module.exports = __webpack_public_path__ + "img/392.b5bc9161.jpg";